// layouts/Customization/index.js
import React, { useState } from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import Footer from 'examples/Footer';
import companyInfo from 'context/companyInfo';
import { Card, Tabs, Tab, Button } from '@mui/material';
import BusinessObjectsTab from './components/BusinessObjectsTab';
import CustomLogicTab from './components/CustomLogicTab';

function Customization() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3} display="flex" justifyContent="space-between" alignItems="center">
              <ArgonTypography variant="h6">Customisation</ArgonTypography>
            </ArgonBox>
            <ArgonBox>
              <Tabs value={tabValue} onChange={handleTabChange} aria-label="customization tabs">
                <Tab label="Business Objects" />
                <Tab label="Custom Logic" />
              </Tabs>
            </ArgonBox>
            <ArgonBox p={3}>
              {tabValue === 0 && <BusinessObjectsTab />}
              {tabValue === 1 && <CustomLogicTab />}
            </ArgonBox>
          </Card>
        </ArgonBox>
        <Footer company={companyInfo} links={companyInfo.links} />
      </ArgonBox>
    </DashboardLayout>
  );
}

export default Customization;
